import { Agent } from '../../providers/api/dtos';
import { jobTitleRank } from '../domain/jobTitleRank';

export function sortAgents(agents: Agent[]) {
  return agents.sort((a, b) => jobTitleRank[a.jobTitle] - jobTitleRank[b.jobTitle]
    || a.name.surname.localeCompare(b.name.surname)
    || a.name.name.localeCompare(b.name.name));
}
